import { BloodOrderPageTranslations } from "./types";

export const enTranslations: BloodOrderPageTranslations = {
    pageTitle: "Order Blood"
};